<template>
  <v-container fluid id="industryDetail">
    <v-col>
      <v-row no-gutters class="pb-4 mt-0">
        <v-col>
          <v-btn fab text small @click="goBack" class="ma-n1">
            <v-icon color="secondary" size="30">fas fa-arrow-left</v-icon>
          </v-btn>
          <div class="container-form-buttons">
            <Button
              class="mr-8"
              size="medium"
              text="Voltar"
              color="quaternary"
              @do="goBack"
            />
            <Button
              size="medium"
              text="Salvar"
              :loading="loadingSaveProduct"
              color="primary"
              @do="saveProduct"
            />
          </div>
        </v-col>
      </v-row>
      <v-row class="my-12" justify="center" v-if="!loadingProduct">
        <v-col cols="8" class="pt-2">
          <v-card class="ecotrace-card" cols="12">
            <v-card-title
              >{{
                $route.params.id ? 'Editar ' : 'Cadastrar novo'
              }}
              produto</v-card-title
            >
            <v-card-text>
              <v-form>
                <v-row>
                  <v-col v-if="isEcoAdmin" cols="12">
                    <v-autocomplete
                      v-model="product.group_id"
                      :items="industryGroups.data"
                      :error="validation.group_id.error"
                      :error-messages="validation.group_id.message"
                      @change="clearError('group_id')"
                      item-text="name"
                      item-value="id"
                      outlined
                      label="Grupo da Indústria"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      v-model="product.sku"
                      :error="validation.sku.error"
                      :error-messages="validation.sku.message"
                      @keyup="clearError('sku')"
                      label="SKU"
                      color="secondary"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="product.name"
                      :error="validation.name.error"
                      :error-messages="validation.name.message"
                      @keyup="clearError('name')"
                      label="Nome"
                      color="secondary"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete v-model="product.language" :items="languageList" item-value="value" item-text="label"
                      label="Idioma" :error="validation.language.error" :error-messages="validation.language.message"
                      @change="clearError('language')" outlined>
                      <template v-slot:item="{ item }">
                        <v-list-item-icon>
                          <v-img :src="item.flag" width="24" height="24"></v-img>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.label }}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="product.description"
                      :error="validation.description.error"
                      :error-messages="validation.description.message"
                      label="Descrição"
                      @keyup="clearError('description')"
                      color="secondary"
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="product.due_days"
                      label="Prazo de validade"
                      color="secondary"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="product.gtin"
                      :error="validation.gtin.error"
                      :error-messages="validation.gtin.message"
                      @keyup="clearError('gtin')"
                      label="GTIN"
                      color="secondary"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-autocomplete v-if="product.language == 'en'" :items="productPartsEn"
                      v-model="product.product_part"
                      :error="validation.product_part.error"                      
                      item-text="description"
                      item-value="id"
                      color="secondary"
                      label="Corte do produto"
                      outlined
                    ></v-autocomplete>
                    <v-autocomplete v-if="product.language == 'es'" :items="productPartsEs"
                      v-model="product.product_part" 
                      :error="validation.product_part.error"                     
                      item-text="description"
                      item-value="id"
                      color="secondary"
                      label="Corte do produto"
                      outlined
                    ></v-autocomplete>
                    <v-autocomplete v-if="product.language == 'zh-cn'" :items="productPartsCh"
                      v-model="product.product_part"   
                      :error="validation.product_part.error"                   
                      item-text="description"
                      item-value="id"
                      color="secondary"
                      label="Corte do produto"
                      outlined
                    ></v-autocomplete>
                    <v-autocomplete v-if="product.language == 'pt-br'"
                      :items="productPartsPtBr"
                      :error="validation.product_part.error"
                      v-model="product.product_part"                      
                      item-text="description"
                      item-value="id"
                      color="secondary"
                      label="Corte do produto"
                      outlined
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6">
                    <v-autocomplete
                      v-model="product.meals"
                      :items="meals"
                      item-text="description"
                      item-value="type"
                      outlined
                      filled
                      flat
                      chips
                      multiple
                      solo
                      deletable-chips
                      label="Tipo de preparo"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="ecotrace-card" style="min-height: 100%">
            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-file-input
                  @change="getPreviewImage"
                  label="Foto do produto"
                  accept="image/png, image/jpeg, image/bmp"
                  filled
                  prepend-icon="mdi-camera"
                  outlined
                  chips
                ></v-file-input>
                <div v-if="product.image_url" class="text-center">
                  <v-btn @click="deleteImage" small>Excluir Imagem</v-btn>
                </div>
              </v-col>
              <v-col v-if="previewImage">
                <v-img
                  :src="previewImage"
                  max-height="250"
                  contain
                  alt="Logo"
                  style="transform: translateY(50%)"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" v-else>
        <v-progress-circular
          color="#315ca7"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-col>

    <v-snackbar
      :timeout="2000"
      top
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import appApi from '@/plugins/api';
import Button from '@/components/buttons/Button';

import axios from 'axios';

const instance = axios.create();

export default {
  components: {
    Button,
  },
  data() {
    return {
      snackbar: {},
      product: {
        name: '',
        group_id: null,
        product_type_id: null,
        description: '',
        sku: '',
        gtin: '',
        product_part: '',
        product_part_name: '',
        family_name: '',
        language: '',
        due_days: '',
        meals: [],
        image_url : null
      },
      isEcoAdmin: false,
      validation: {
        name: {
          error: false,
          message: '',
        },
        description: {
          error: false,
          message: '',
        },
        sku: {
          error: false,
          message: '',
        },
        gtin: {
          error: false,
          message: '',
        },
        language: {
          error: false,
          message: '',
        },
        group_id: {
          error: false,
          message: '',
        },
        product_part: {
          error: false,
          message: '',
        },
      },
      industryGroups: [],
      meals: [
        { type: 1, description: 'Cozinhar' },
        { type: 2, description: 'Grelhar' },
        { type: 3, description: 'Fritar' },
        { type: 4, description: 'Assar' },        
      ],
      productPartsPtBr: [
        { id: 1, description: 'Pescoço' },
        { id: 2, description: 'Acém' },
        { id: 3, description: 'Peito' },
        { id: 4, description: 'Paleta ou Miolo de Paleta' },
        { id: 5, description: 'Fraldinha' },
        { id: 6, description: 'Ponta de Agulha' }, // corte não existe na planilha
        { id: 7, description: 'Filé Mignon' },
        { id: 8, description: 'Filé de Costela' }, // corte não existe na planilha
        { id: 9, description: 'Contra Filé' },
        { id: 10, description: 'Capa de Filé' },
        { id: 11, description: 'Alcatra' },
        { id: 12, description: 'Patinho' },
        { id: 13, description: 'Coxão Duro' },
        { id: 14, description: 'Coxão Mole' },
        { id: 15, description: 'Lagarto' },
        { id: 16, description: 'Músculo Dianteiro' },
        { id: 17, description: 'Músculo Traseiro' },
        { id: 18, description: 'Aba do Filé' }, // corte não existe na planilha
        { id: 19, description: 'Maminha da Alcatra' }, 
        { id: 20, description: 'Picanha' },
        { id: 21, description: 'Cupim' },
        { id :22, description:'Peixinho'},
        { id :23, description:'Raquete'}, 
        { id :24, description:'Coração da Paleta'}, 
        { id :25, description:'Costela do Dianteiro'},
        { id :26, description:'Costela do Traseiro'},
        { id :27, description:'Bananinha'},
        { id :28, description:'Entrecote'},
        { id :29, description:'Miolo da Alcatra'}, 
        { id: 100, description: 'Miúdos' },
      ],
      productPartsEn: [
        { id: 1, description: 'Neck - Pescoço' },
        { id: 2, description: 'Chuck roll - Acém' },
        { id: 3, description: 'Brisket - Peito' },
        { id: 4, description: 'Paleta ou Miolo de Paleta' },
        { id: 5, description: 'Fraldinha' },
        { id: 6, description: 'Ponta de Agulha' }, // corte não existe na planilha
        { id: 7, description: 'Tenderloin - Filé Mignon' },
        { id: 8, description: 'Filé de Costela' }, // corte não existe na planilha
        { id: 9, description: 'Striploin - Contra Filé' },
        { id: 10, description: 'Capa de Filé' },
        { id: 11, description: 'Rump - Alcatra' },
        { id: 12, description: 'Knuckle - Patinho' },
        { id: 13, description: 'Flat - Coxão Duro' },
        { id: 14, description: 'Topside - Coxão Mole' },
        { id: 15, description: 'Eye round - Lagarto' },
        { id: 16, description: 'Shin - Músculo Dianteiro' },
        { id: 17, description: 'Shank - Músculo Traseiro' },
        { id: 18, description: 'Aba do Filé' }, // corte não existe na planilha
        { id: 19, description: 'Rump tail - Maminha da Alcatra' }, 
        { id: 20, description: 'Rump cap - Picanha' },
        { id: 21, description: 'Hump - Cupim' },
        { id :22, description: 'Chuck tender - Peixinho'},
        { id :23, description: 'Oyster blade - Raquete'}, 
        { id :24, description: 'Shoulder heart - Coração da Paleta'}, 
        { id :25, description: 'Chuck ribs - Costela do Dianteiro'},
        { id :26, description: 'Flanks - Costela do Traseiro'},
        { id :27, description: 'Rib fingers - Bananinha'},
        { id :28, description: 'Cube roll - Entrecote'},
        { id :29, description: 'Heart of rump - Miolo da Alcatra'}, 
        { id: 100, description: 'Miúdos' },
      ],
      productPartsEs: [
        { id: 1, description: 'Cogote - Pescoço' },
        { id: 2, description: 'Aguja - Acém' },
        { id: 3, description: 'Pecho - Peito' },
        { id: 4, description: 'Paleta ou Miolo de Paleta' },
        { id: 5, description: 'Fraldinha' },
        { id: 6, description: 'Ponta de Agulha' }, // corte não existe na planilha
        { id: 7, description: 'Solomillo - Filé Mignon' },
        { id: 8, description: 'Filé de Costela' }, // corte não existe na planilha
        { id: 9, description: 'Bife angosto - Contra Filé' },
        { id: 10, description: 'Tapa de bife ancho - Capa de Filé' },
        { id: 11, description: 'Cuadril con tapa y colita - Alcatra' },
        { id: 12, description: 'Bola de lomo - Patinho' },
        { id: 13, description: 'Cuadrada - Coxão Duro' },
        { id: 14, description: 'Nalga de adentro - Coxão Mole' },
        { id: 15, description: 'Peceto - Lagarto' },
        { id: 16, description: 'Garron delantero - Músculo Dianteiro' },
        { id: 17, description: 'Garron trasero - Músculo Traseiro' },
        { id: 18, description: 'Aba do Filé' }, // corte não existe na planilha
        { id: 19, description: 'Colita de cuadril - Maminha da Alcatra' }, 
        { id: 20, description: 'Tapa de cuadril - Picanha' },
        { id: 21, description: 'Joroba - Cupim' },
        { id :22, description: 'Chingolo - Peixinho'},
        { id :23, description: 'Marucha - Raquete'}, 
        { id :24, description: 'Carnaza de paleta - Coração da Paleta'}, 
        { id :25, description: 'Sobrecostillas - Costela do Dianteiro'},
        { id :26, description: 'Costilla - Costela do Traseiro'},
        { id :27, description: 'Recorte de lomo - Bananinha'},
        { id :28, description: 'Bife ancho - Entrecote'},
        { id :29, description: 'Cuadril sin tapa sin colita con grasa - Miolo da Alcatra'}, 
        { id: 100, description: 'Miúdos' },
      ],
      productPartsCh: [
      { id: 1, description: '脖肉 - Pescoço' },
        { id: 2, description: '上脑 - Acém' },
        { id: 3, description: '胸肉 - Peito' },
        { id: 4, description: 'Paleta ou Miolo de Paleta' },
        { id: 5, description: 'Fraldinha' },
        { id: 6, description: 'Ponta de Agulha' }, // corte não existe na planilha
        { id: 7, description: '里脊 - Filé Mignon' },
        { id: 8, description: 'Filé de Costela' }, // corte não existe na planilha
        { id: 9, description: '西冷 - Contra Filé' },
        { id: 10, description: '眼肉盖 - Capa de Filé' },
        { id: 11, description: '臀腰 - Alcatra' },
        { id: 12, description: '牛霖 - Patinho' },
        { id: 13, description: '大米龙 - Coxão Duro' },
        { id: 14, description: '针趴 - Coxão Mole' },
        { id: 15, description: '小米龙 - Lagarto' },
        { id: 16, description: '前腱 - Músculo Dianteiro' },
        { id: 17, description: '后腱 - Músculo Traseiro' },
        { id: 18, description: 'Aba do Filé' }, // corte não existe na planilha
        { id: 19, description: '臀腰肉尾 - Maminha da Alcatra' }, 
        { id: 20, description: '臀腰肉盖 - Picanha' },
        { id: 21, description: '肩峰 - Cupim' },
        { id :22, description: '嫩肩 - Peixinho'},
        { id :23, description: '板腱 - Raquete'}, 
        { id :24, description: '肩胛肉心 - Coração da Paleta'}, 
        { id :25, description: '上脑肋条 - Costela do Dianteiro'},
        { id :26, description: '牛腩 - Costela do Traseiro'},
        { id :27, description: '肋条 - Bananinha'},
        { id :28, description: '眼肉 - Entrecote'},
        { id :29, description: '臀腰肉心 - Miolo da Alcatra'}, 
        { id: 100, description: 'Miúdos' },
      ],
      industries: [],
      user_groupId: {},
      loadingProduct: false,
      loadingSaveProduct: false,
      showPassIcon: false,
      showGroupdField: false,
      previewImage: null,
      userPicture: null,
      languageList: [
        { label: 'Português', value: 'pt-br', flag: '/static/svg/flag-brazil.svg' },
        { label: 'English', value: 'en', flag: '/static/svg/flag-england.svg' },
        { label: 'Español', value: 'es', flag: '/static/svg/flag-spain.svg' },
        { label: '中文 - ZH - CN', value: 'zh-cn', flag: '/static/svg/flag-china.svg' }
      ]
    };
  },

  async mounted() {
    await this.getInitialData();

    if (this.$route.params.id) {
      this.loadingProduct = true;
      appApi
        .getProduct(this.$route.params.id)
        .then(({ data: product }) => {
          const { meals = [] } = product;
          
          this.product = {
            group_id: product.group_id,
            name: product.name,
            description: product.description,
            sku: product.sku,
            gtin: product.gtin,
            product_part: +product.product_part,
            language: product.language,
            due_days: product.due_days,
            meals: meals.map((p) => +p.type),
            image_url : product.image_url
          };
          this.previewImage = product.image_url;
        })
        .finally(() => {
          this.loadingProduct = false;
        });

    }
  },

  methods: {
    goBack() {
      window.history.back();
    },

    deleteImage() {
      this.$confirm("Tem certeza que deseja excluir imagem?")
        .then(confirm => {
          if(confirm) {
            appApi.deleteProductImage(this.$route.params.id)
              .then(res => {
                this.previewImage = null
                this.product.image_url = null
                this.snackbar = {
                  show: true,
                  text: 'Imagem excluída com sucesso',
                  color: 'success',
                };
              })
          }
        })
    },

    async getInitialData() {
      const roles = await this.$auth.user().roles;
      this.isEcoAdmin = roles.some((r) => r.name === 'eco_admin');

      if (this.isEcoAdmin) {
        appApi.getIndustryGroups().then((result) => {
          this.industryGroups = result.data;
        });
      }
    },

    clearError(field) {
      this.validation[field].error = false;
      this.validation[field].message = '';
    },

    getPreviewImage(fileInput) {
      if (fileInput) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(fileInput);
        this.productImage = fileInput;
      } else {
        this.previewImage = null;
        this.productImage = null;
      }
    },

    async saveInitialProductImageData(prodId) {
      if (this.productImage) {
        let formData = new FormData();

        const { data } = await appApi.saveProductImage(prodId, {
          image: { filename: this.productImage.name },
        });

        for (let key in data.fields) {
          formData.append(key, data.fields[key]);
        }

        formData.append('file', this.productImage);

        instance
          .post(data.url, formData, {
            headers: formData,
          })
          .catch((e) => console.log(e));
      }

      return prodId;
    },

    selectRole() {
      if (this.user.roles == 1) this.showGroupdField = true;
      else this.showGroupdField = false;
    },

    removeChips(item) {
      const index = this.roles.indexOf(item.name);
      if (index >= 0) this.roles.splice(index, 1);
    },

    handleSuccess() {
      this.snackbar = {
        show: true,
        text: 'Produto salvo com sucesso',
        color: 'success',
      };

      this.loadingSaveProduct = false;

      setTimeout(() => {
        this.$router.push({ name: 'Products' });
      }, 2000);
    },

    handleError(err) {
      this.loadingSaveProduct = false;
      if (err.response && err.response.status == 400) {
        err.response.data.forEach((element) => {
          this.validation[element.field].error = true;
          this.validation[element.field].message = element.message;
        });
      }

      this.snackbar = {
        show: true,
        text: 'Erro ao salvar produto',
        color: 'error',
      };

      console.log(err);
    },

    async saveProduct() {
      this.loadingSaveProduct = true;

      let productPart = null
      if(this.product.language == 'pt-br'){
        productPart = this.productPartsPtBr.find(
          (e) => e.id == this.product.product_part
        )
      }
      if(this.product.language == 'en'){
        productPart = this.productPartsEn.find(
          (e) => e.id == this.product.product_part
        )
      }
      if(this.product.language == 'es'){
        productPart = this.productPartsEs.find(
          (e) => e.id == this.product.product_part
        )
      }
      if(this.product.language == 'zh-cn'){
        productPart = this.productPartsCh.find(
          (e) => e.id == this.product.product_part
        )
      }

      const prodData = {
        group_id: this.product.group_id,
        name: this.product.name,
        description: this.product.description,
        sku: this.product.sku,
        gtin: this.product.gtin,
        product_part: this.product.product_part,
        product_part_name: productPart ? productPart.description : null,
        language: this.product.language,
        due_days: this.product.due_days,
        meals: this.product.meals,
        family: this.product.family
      };

      // eslint-disable-next-line no-console

      if (!this.$route.params.id) {
        appApi
          .postProduct(prodData)
          .then(({ data }) =>
            this.saveInitialProductImageData(data.id).then(this.handleSuccess)
          )
          // .then((id) => appApi.postProductDynamo(id))
          .catch(this.handleError);
      } else {
        this.saveInitialProductImageData(this.$route.params.id)
          .then(() =>
            appApi
              .putProduct(this.$route.params.id, prodData)
              .then(this.handleSuccess)
          )
          // .then(() => appApi.postProductDynamo(this.$route.params.id))
          .catch(this.handleError);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#industryDetail::v-deep {
  .container-form-buttons {
    position: absolute;
    display: flex;
    right: 30px;
  }

  .theme--light.v-input input,
  .theme--light.v-input textarea,
  .theme--light.v-select .v-select__selection--comma {
    color: $secondary-color;
    font-weight: 500;
  }

  .theme--light.v-chip:not(.v-chip--active) {
    border-radius: 5px;
    background-color: #ebf3ff;
    color: #315ca7;
  }

  .theme--light.v-chip:not(.v-chip--active) .theme--light.v-icon {
    color: #315ca7;
  }

  .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
    background: transparent;
  }

  .v-file-input.v-text-field--filled:not(.v-text-field--single-line)
    .v-file-input__text {
    padding-top: 5px;
  }
}
</style>
